module.exports = __webpack_public_path__ + "static/media/BeVietnamPro-Regular.fe939f11.ttf";